import { render, staticRenderFns } from "./dragVerify.vue?vue&type=template&id=4629a7d1&"
import script from "./dragVerify.vue?vue&type=script&lang=js&"
export * from "./dragVerify.vue?vue&type=script&lang=js&"
import style0 from "./dragVerify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports